function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapGetters } from 'vuex';
import WeightBmi from './WeightBmi';
import TextResultsLooseWeight from './contentParts/TextResultsLooseWeight';
import TextResultsGainWeight from './contentParts/TextResultsGainWeight';
import TextResultsNoData from './contentParts/TextResultsNoData';
import WeightTable from './WeightTable';
import WeightChart from './WeightChart';
export default {
  name: 'WeightContent',
  components: {
    WeightChart: WeightChart,
    WeightBmi: WeightBmi,
    TextResultsLooseWeight: TextResultsLooseWeight,
    TextResultsGainWeight: TextResultsGainWeight,
    TextResultsNoData: TextResultsNoData,
    WeightTable: WeightTable
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState(['activeModule', 'showSidebar', 'rWeightDatasets', 'loading'])), mapGetters(['person'])), {}, {
    getProgressbarValue: function getProgressbarValue() {
      var lostAlready = this.weightTargetInitialWeight - this.lastWeight;
      var wantToLost = this.weightTargetInitialWeight - this.weightTarget;
      var result = Math.round((100 - lostAlready / wantToLost * 100) * 100) / 100;
      return result > 100 ? 100 : result;
    },
    weightTargetInitialWeight: function weightTargetInitialWeight() {
      return 'weightTargetInitialWeight' in this.person ? this.person.weightTargetInitialWeight : null;
    },
    weightTarget: function weightTarget() {
      return 'weightTarget' in this.person ? this.person.weightTarget : null;
    },
    weightTargetBounty: function weightTargetBounty() {
      return 'weightTargetBounty' in this.person ? this.person.weightTargetBounty : null;
    },
    weightUnit: function weightUnit() {
      return 'weightUnit' in this.person ? this.person.weightUnit : null;
    },
    lastWeight: function lastWeight() {
      if (this.weightData && this.weightData.length >= 1) {
        return this.weightData[0].weight;
      }

      return null;
    },
    lastWeightDataset: function lastWeightDataset() {
      if (!this.weightData || this.weightData.length === 0) {
        return null;
      }

      var i = 0;

      while (this.weightData && this.weightData.length >= 1 && !this.weightData[i].weight) {
        i++;
      }

      if (i > 0 || i === 0 && this.weightData[i].weight) {
        return this.weightData[i];
      } else {
        return null;
      }
    },
    minWeightDataset: function minWeightDataset() {
      if (this.weightData === null || this.weightData.length === 0) {
        return null;
      }

      var min = null;
      this.weightData.forEach(function (item) {
        if (item.weight && (min === null || min.weight > item.weight)) {
          min = item;
        }
      });
      return min;
    },
    maxWeightDataset: function maxWeightDataset() {
      if (this.weightData === null || this.weightData.length === 0) {
        return null;
      }

      var max = null;
      this.weightData.forEach(function (item) {
        if (item.weight && (max === null || max.weight < item.weight)) {
          max = item;
        }
      });
      return max;
    },
    weightData: function weightData() {
      return !this.rWeightDatasets ? null // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      : this.rWeightDatasets.sort(function (a, b) {
        return new Date(b.date) - new Date(a.date);
      });
    }
  })
};